const o=(o,d)=>{let n=[];const r=()=>{n.forEach(o=>{d(o)}),window[o]=void 0,t()},t=()=>{n=[]};return{add:d=>{n.push(d),window[o]=r},clear:t}};export{o as createStackEvents};
